/**
 * Mock responses for GET /api/tpsm/assessments/:supplierId (same path as TPSM_ASSESSMENTS_SUPPLIER).
 * Darvin: full list aligned with backend shape; `findings.answers` keys are synthetic (scores 4–5).
 */
import { USE_MOCK_TPSM_INVENTORY_DATA } from './useMockTpsmInventory'
import summaryFixture from './fixtures/tpsm-assessments-summary.json'

export const MOCK_SUPPLIER_DARVIN_ID = '21dcd720-b330-4285-8b4c-9229b3a14241'

function mkAnswers(count: number, seed: string): Record<string, number> {
  const o: Record<string, number> = {}
  for (let i = 0; i < count; i++) {
    o[`${seed}-${i}`] = [5, 4, 5, 4, 5][i % 5]
  }
  return o
}

/** Mirrors API: GET /tpsm/assessments/21dcd720-b330-4285-8b4c-9229b3a14241 */
export const MOCK_TPSM_ASSESSMENTS_DARVIN: Record<string, unknown>[] = [
  {
    id: 'c4d7cfb6-31ee-4557-9ec4-e419454b208b',
    supplierId: MOCK_SUPPLIER_DARVIN_ID,
    standardCode: 'DORA',
    complianceScore: 90,
    status: 'IN_PROGRESS',
    findings: {
      answers: mkAnswers(18, 'dora'),
      lastUpdated: '2025-12-26T20:49:31.642Z',
      submittedAt: '2025-12-26T20:49:31.642Z',
      answersCount: 18,
      standardCode: 'DORA',
    },
    recommendations: null,
    assessedAt: '2025-12-26T20:49:31.642Z',
    createdAt: '2025-11-25T08:15:32.303Z',
    updatedAt: '2025-12-26T20:49:31.643Z',
    evidence: [],
  },
  {
    id: '4ee1a59b-34af-4ed1-92b4-44037550f51f',
    supplierId: MOCK_SUPPLIER_DARVIN_ID,
    standardCode: 'ISO_27001',
    complianceScore: 95,
    status: 'IN_PROGRESS',
    findings: {
      answers: mkAnswers(30, 'iso'),
      lastUpdated: '2025-11-27T13:15:00.480Z',
      submittedAt: '2025-11-27T13:15:00.480Z',
      answersCount: 30,
      standardCode: 'ISO_27001',
    },
    recommendations: null,
    assessedAt: '2025-11-27T13:15:00.480Z',
    createdAt: '2025-11-26T19:09:22.205Z',
    updatedAt: '2025-11-27T13:15:00.482Z',
    evidence: [],
  },
  {
    id: '816341a9-27ef-4002-a7dc-d3cc78388675',
    supplierId: MOCK_SUPPLIER_DARVIN_ID,
    standardCode: 'SDLC_SECURITY',
    complianceScore: 98,
    status: 'IN_PROGRESS',
    findings: {
      answers: mkAnswers(24, 'sdlc'),
      lastUpdated: '2025-11-27T13:10:27.291Z',
      submittedAt: '2025-11-27T13:10:27.291Z',
      answersCount: 24,
      standardCode: 'SDLC_SECURITY',
    },
    recommendations: null,
    assessedAt: '2025-11-27T13:10:27.291Z',
    createdAt: '2025-11-27T13:09:13.166Z',
    updatedAt: '2025-11-27T13:10:27.292Z',
    evidence: [],
  },
  {
    id: '608769bd-d07a-4f2b-9855-af848db08207',
    supplierId: MOCK_SUPPLIER_DARVIN_ID,
    standardCode: 'SOC2',
    complianceScore: 93,
    status: 'IN_PROGRESS',
    findings: {
      answers: mkAnswers(20, 'soc2'),
      lastUpdated: '2025-11-27T13:10:15.951Z',
      submittedAt: '2025-11-27T13:10:15.951Z',
      answersCount: 20,
      standardCode: 'SOC2',
    },
    recommendations: null,
    assessedAt: '2025-11-27T13:10:15.951Z',
    createdAt: '2025-11-27T13:10:15.952Z',
    updatedAt: '2025-11-27T13:10:15.952Z',
    evidence: [],
  },
  {
    id: '6b1f99a2-e24a-4232-9907-f7b9c5082e62',
    supplierId: MOCK_SUPPLIER_DARVIN_ID,
    standardCode: 'SWIFT_CSCF_2025',
    complianceScore: 95,
    status: 'IN_PROGRESS',
    findings: {
      answers: mkAnswers(15, 'swift'),
      lastUpdated: '2025-11-27T13:09:42.036Z',
      submittedAt: '2025-11-27T13:09:42.036Z',
      answersCount: 15,
      standardCode: 'SWIFT_CSCF_2025',
    },
    recommendations: null,
    assessedAt: '2025-11-27T13:09:42.036Z',
    createdAt: '2025-11-25T08:15:44.839Z',
    updatedAt: '2025-11-27T13:09:42.038Z',
    evidence: [],
  },
  {
    id: '0b43d628-e4a3-4a1b-ae2e-6ae76cb06f04',
    supplierId: MOCK_SUPPLIER_DARVIN_ID,
    standardCode: 'GDPR',
    complianceScore: 93,
    status: 'IN_PROGRESS',
    findings: {
      answers: mkAnswers(21, 'gdpr'),
      lastUpdated: '2025-11-27T13:06:21.918Z',
      submittedAt: '2025-11-27T13:06:21.918Z',
      answersCount: 21,
      standardCode: 'GDPR',
    },
    recommendations: null,
    assessedAt: '2025-11-27T13:06:21.918Z',
    createdAt: '2025-11-26T16:08:48.206Z',
    updatedAt: '2025-11-27T13:06:21.919Z',
    evidence: [],
  },
  {
    id: '1b2297b9-6e34-40c0-a7e4-32f2aa6f5394',
    supplierId: MOCK_SUPPLIER_DARVIN_ID,
    standardCode: 'SECURITY_POSTURE',
    complianceScore: 0,
    status: 'COMPLETED',
    findings: {
      answers: {},
      metadata: {
        controls: {
          mfaUsed: true,
          sastDast: true,
          usesCloud: true,
          ssdlcProcess: true,
          zeroTrustUsed: false,
          encryptionUsed: true,
          infrastructureScanners: true,
        },
        securityPosture: {
          mfaUsed: true,
          sastDast: true,
          usesCloud: true,
          ssdlcProcess: true,
          encryptionUsed: true,
          infrastructureScanners: true,
        },
      },
      questions: [],
    },
    recommendations: null,
    assessedAt: '2025-11-27T11:21:08.869Z',
    createdAt: '2025-11-27T11:21:08.869Z',
    updatedAt: '2025-11-27T13:10:34.855Z',
    evidence: [],
  },
  {
    id: 'c6f254c1-a1b6-42ac-93b9-3171deb3db93',
    supplierId: MOCK_SUPPLIER_DARVIN_ID,
    standardCode: 'TECH_CONTROLS',
    complianceScore: 89,
    status: 'IN_PROGRESS',
    findings: {
      answers: mkAnswers(21, 'tech'),
      lastUpdated: '2025-11-26T19:10:19.389Z',
      submittedAt: '2025-11-26T19:10:19.389Z',
      answersCount: 21,
      standardCode: 'TECH_CONTROLS',
    },
    recommendations: null,
    assessedAt: '2025-11-26T19:10:19.389Z',
    createdAt: '2025-11-26T19:10:19.391Z',
    updatedAt: '2025-11-26T19:10:19.391Z',
    evidence: [],
  },
]

/**
 * Mock list for GET /tpsm/assessments/:supplierId.
 * — Darvin: full array above.
 * — Other suppliers in dev: rows from `tpsm-assessments-summary.json` `recent` for that id.
 * — Not mock mode: empty array (caller must use API).
 */
export function getMockAssessmentsBySupplierId(supplierId: string): unknown[] {
  if (!USE_MOCK_TPSM_INVENTORY_DATA) return []
  if (supplierId === MOCK_SUPPLIER_DARVIN_ID) {
    return MOCK_TPSM_ASSESSMENTS_DARVIN.map((row) => ({ ...row }))
  }
  type SummaryRecentRow = { supplierId?: string } & Record<string, unknown>
  type SummaryFixtureShape = { recent?: SummaryRecentRow[] }
  const summary = summaryFixture as SummaryFixtureShape
  const recent = Array.isArray(summary.recent) ? summary.recent : []
  return recent.filter((a) => a.supplierId === supplierId)
}
